export enum RoundNames {
  'bonus' = 'bonus',
}
